/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable react/display-name */
import {
  Box,
  HStack,
  Input,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  Stack,
  Text,
} from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { forwardRef, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { JobsListingContext } from '../context';
export const ApplyJobScreeningQuestion = forwardRef(
  ({ question, value, onChange, defaultValue, ...props }, ref) => {
    const { jobPreferences, jobPreferencesResume } = useContext(JobsListingContext);
    const q = question?.questions
      ? Array.isArray(question?.questions)
        ? question.questions?.[0]
        : question?.questions
      : null;

    // const name = question?.name;
    const { t } = useTranslator();
    const handleChange = (val) => {
      onChange?.(val);
    };

    const isResumeValid = () => {
      const { resume_first, resume_second } = jobPreferences ?? jobPreferencesResume ?? {};
      return Boolean(resume_first?.length || resume_second?.length);
    };

    useEffect(() => {
      if (question?.name?.toLowerCase() === 'resume') {
        const hasResume = isResumeValid();
        onChange?.(hasResume ? 'Yes' : 'No');
      }
    }, [jobPreferences, jobPreferencesResume, question?.name]);

    const placeholderReplacementRegexStr = `\\[${
      q?.ideal_answer_text ?? '.+'
    }\\]`;
    let questionText = q?.question?.replaceAll?.(
      new RegExp(placeholderReplacementRegexStr, 'g'),
      q?.place_holder_value ?? ''
    );
    if (
      /driver's licen[cs]e/i.test(question?.name) &&
      q?.place_holder_value &&
      !q?.question?.includes('[')
    ) {
      if (questionText?.includes('?')) {
        questionText = questionText?.replace?.('?', `: ${q.place_holder_value} ?`);
      } else {
        questionText = `${questionText}: ${q.place_holder_value}`;
      }
    }

    return (
      <>
        <Stack>
          <HStack
            alignItems={['flex-start', 'flex-start', 'center']}
            flexDir={['column', 'column', 'row']}
            flexWrap="wrap"
          >
            <Box flexShrink={0} flex={1}>
              {/* <Text>{q?.question.includes(':') ?` ${q.question.split(":")[0]}?`: q?.question.replaceAll(":", "").replaceAll("[",'').replaceAll("]",'')}</Text> */}
              <Text>
                {questionText?.trim?.() === 'Resume'
                  ? t('createJob.didYouUploadResume') || 'Did you upload your updated Resume?'
                  : questionText}
                {q?.is_must_have ? '*' : ''}
              </Text>
            </Box>
            <Box>
              {question?.name?.toLowerCase() === 'resume' ? null : q?.ideal_answer_type === 'bool' ? (
                <Select
                  onChange={(e) => handleChange(e?.target?.value)}
                  /* defaultValue={defaultValue ?? (q?.is_must_have ? '' : q?.ideal_answer_value)} */
                  defaultValue={defaultValue ?? ''}
                >
                  <option value="">{t('createJob.select') || "Select"}</option>
                  <option value="Yes">{t('myEvents.yes') || "Yes"}</option>
                  <option value="No">{t('myEvents.no') || "No"}</option>
                </Select>
              ) : q?.ideal_answer_type === 'string' ? (
                <Input
                  onChange={(e) => handleChange(e?.target?.value)}
                  /* defaultValue={defaultValue ?? (q?.is_must_have ? '' : q?.ideal_answer_value)} */
                  defaultValue={defaultValue ?? ''}
                />
              ) : q?.ideal_answer_type === 'select' ? (
                <Select
                  onChange={(e) => handleChange(e?.target?.value)}
                  /* defaultValue={defaultValue ?? (q?.is_must_have ? '' : q?.ideal_answer_value)} */
                  defaultValue={defaultValue ?? ''}
                >
                  <option value="">{t('createJob.select') || "Select"}</option>
                  {q?.ideal_answer_values?.map?.((v, vind) => (
                    <option value={v?.value} key={vind}>
                      {v?.title}
                    </option>
                  ))}
                </Select>
              ) : q?.ideal_answer_type === 'integer' ? (
                <NumberInput
                  maxW="20"
                  min={0}
                  onChange={(e) => handleChange(e)}
                  /* defaultValue={defaultValue ?? (q?.is_must_have ? '' : q?.ideal_answer_value)} */
                  defaultValue={defaultValue ?? ''}
                >
                  <NumberInputField />
                  <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                  </NumberInputStepper>
                </NumberInput>
              ) : (
                ''
              )}
            </Box>
          </HStack>
        </Stack>
      </>
    );
  }
);

/**
 [
    {
        "name": "Certifications",
        "questions": {
            "question": "Do you have the following license or certification: [License/Certification] ?",
            "is_must_have": true,
            "ideal_answer_text": "License/Certification",
            "ideal_answer_type": "bool",
            "ideal_answer_value": "Yes",
            "place_holder_value": "Google Certificate"
        }
    },
    {
        "name": "Background Check",
        "questions": [
            {
                "question": "Are you willing to undergo a background check, in accordance with local law/regulations?",
                "is_must_have": true,
                "ideal_answer_text": null,
                "ideal_answer_type": "bool",
                "ideal_answer_value": "Yes",
                "place_holder_value": null
            }
        ]
    }
]
 */
